module.exports = __webpack_public_path__ + "img/download-chart.b7001c2f.svg";